import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  margin-bottom: ${rem(64)};

  *:has(.agent-message) + & {
    margin-top: ${rem(32)};
  }
`;

const Text = styled.p`
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  margin-bottom: ${rem(16)};
`;

const Link = styled.a`
  border-bottom: 1px solid;
  display: inline-block;
  cursor: pointer;
  font-weight: 500;
  line-height: ${rem(16)};
`;

export default {
  Wrapper,
  Text,
  Link
};
